import { generateReceiptHtml } from './printerService';
import { Order, SystemConfig } from '../types';

export const handleSilentPrint = (order: Order, fullConfig?: SystemConfig) => {
    const config = fullConfig?.printerConfig;
    // If no config or printer disabled, do nothing
    if (!config || !config.enabled) return;

    // Default values if not specified in config
    const width = config.width || '80mm';
    const printMode = config.printMode || 'default';
    const manualPrinterName = config.manualPrinterName || 'Sua Impressora Térmica';
    // Default to true if not explicitly set to false, to ensure user awareness
    const promptBeforeManualPrint = config.promptBeforeManualPrint !== undefined ? config.promptBeforeManualPrint : true;

    const performPrint = () => {
        // Create hidden iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.style.visibility = 'hidden';

        // Append to body
        document.body.appendChild(iframe);

        // Get document reference
        const doc = iframe.contentWindow?.document;
        if (!doc) {
            document.body.removeChild(iframe);
            return;
        }

        // Generate HTML content
        const htmlContent = generateReceiptHtml(order, width, fullConfig);

        // Write to iframe
        doc.open();
        doc.write(htmlContent);
        doc.close();

        // Remove iframe after printing (the iframe script handles print() and close())
        // We add a safety timeout to remove the iframe element
        setTimeout(() => {
            document.body.removeChild(iframe);
        }, 5000); // 5 seconds safety buffer
    };

    if (printMode === 'manual_selection' && promptBeforeManualPrint) {
        const confirmed = window.confirm(
            `Por favor, selecione a impressora "${manualPrinterName}" na próxima janela de impressão para imprimir o cupom do pedido #${order.id.slice(-4)}.`
        );
        if (confirmed) {
            performPrint();
        } else {
            // User cancelled the print
        }
    } else {
        performPrint();
    }
};
